import script from "./DashboardView.vue?vue&type=script&setup=true&lang=js"
export * from "./DashboardView.vue?vue&type=script&setup=true&lang=js"

import "./DashboardView.vue?vue&type=style&index=0&id=ea2d1852&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ea2d1852"]])

export default __exports__